// extracted by mini-css-extract-plugin
export default {"marquee__wrapper":"RunningLine_marquee__wrapper__gAuwk"};